import React from 'react';
import { Decoration_Type } from 'ricos-schema';

function _createForOfIteratorHelperLoose$2(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray$2(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$2(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$2(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0; } }
function _arrayLikeToArray$2(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2) {
    for (var _iterator = _createForOfIteratorHelperLoose$2(__getOwnPropSymbols$2(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
    }
  }
  return a;
};
var DEFAULT_SETTINGS = {
  mentionPrefix: "@",
  mentionTrigger: "@",
  getMentionLink: function getMentionLink() {
    return "#";
  },
  repositionSuggestions: true,
  entryHeight: 34,
  additionalHeight: 17,
  visibleItemsBeforeOverflow: 5,
  popoverComponent: /* @__PURE__ */React.createElement("div", null),
  onMentionClick: void 0,
  getMentions: function getMentions(searchQuery) {
    return new Promise(function (resolve) {
      return setTimeout(function () {
        return resolve([{
          name: "Test One",
          slug: "testone"
        }, {
          name: "Test One.1",
          slug: "testone1"
        }, {
          name: "Test One.2",
          slug: "testone2"
        }, {
          name: "Test One.3",
          slug: "testone3"
        }, {
          name: "Test One.4",
          slug: "testone4"
        }, {
          name: "Test One.5",
          slug: "testone5"
        }, {
          name: "Test One.6",
          slug: "testone6"
        }, {
          name: "Test One.7",
          slug: "testone7"
        }, {
          name: "Test One.8",
          slug: "testone8"
        }, {
          name: "Test Two",
          slug: "testwo",
          avatar: "https://via.placeholder.com/100x100?text=Image=50"
        }].filter(function (_ref) {
          var name = _ref.name;
          return name.toLowerCase().includes(searchQuery.toLowerCase());
        }));
      }, 250);
    });
  },
  zIndex: 9999
};
var DEFAULTS = {
  config: __spreadValues$2({}, DEFAULT_SETTINGS)
};

var MENTION_TYPE = "mention";

var styles = {"mentionPalette":"UU9RW","mention":"C2dSS","mentionViewer":"xlTdC","mentionSuggestionsEntry":"J6KUy","mentionSuggestionsEntryFocused":"DLwFg","mentionSuggestionsEntryText":"n40xw","mentionSuggestionsEntryAvatar":"F90n1","mentionSuggestions":"_70hyF","cursorDefault":"_9pIAK","cursorPointer":"lyR3s"};

function _createForOfIteratorHelperLoose$1(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$1(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0; } }
function _arrayLikeToArray$1(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) {
    for (var _iterator = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var decorator = function decorator(element, mentionDecoration, contextualData) {
  var mentionData = mentionDecoration.mentionData;
  var settings = contextualData.config[MENTION_TYPE] || {};
  var onMentionClick = settings.onMentionClick,
    onMentionHover = settings.onMentionHover,
    getMentionLink = settings.getMentionLink;
  var ref = React.useRef(null);
  var onMouseOver = function onMouseOver() {
    return onMentionHover == null ? void 0 : onMentionHover(mentionData, ref.current);
  };
  var onClick = function onClick() {
    return onMentionClick == null ? void 0 : onMentionClick(mentionData);
  };
  var onKeyDown = function onKeyDown(e) {
    return (e.key === "Enter" || e.key === " ") && onClick();
  };
  var cursorStyle = onMentionClick === void 0 ? styles.cursorDefault : styles.cursorPointer;
  var commonProps = {
    onMouseOver: onMouseOver,
    ref: ref,
    className: styles.mention + " " + styles.mentionViewer + " " + cursorStyle
  };
  var key = "mention-" + mentionData.id;
  if (onMentionClick) {
    return /* @__PURE__ */React.createElement("span", __spreadProps(__spreadValues$1({
      key: key
    }, commonProps), {
      role: "link",
      tabIndex: 0,
      onKeyDown: onKeyDown,
      onClick: onClick
    }), element);
  } else if (getMentionLink) {
    return /* @__PURE__ */React.createElement("a", __spreadProps(__spreadValues$1({
      key: key
    }, commonProps), {
      href: getMentionLink(mentionData),
      rel: "noopener noreferrer",
      tabIndex: 0
    }), element);
  } else {
    return /* @__PURE__ */React.createElement("span", __spreadValues$1({
      key: key
    }, commonProps), element);
  }
};
var MentionDecorator = {
  rule: function rule(node) {
    var _a, _b;
    return !!((_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.some(function (_ref) {
      var type = _ref.type;
      return type === Decoration_Type.MENTION;
    }));
  },
  decorate: function decorate(_ref2) {
    var element = _ref2.element,
      node = _ref2.node,
      context = _ref2.context;
    var _a, _b;
    var mentionDecoration = (_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.find(function (_ref3) {
      var type = _ref3.type;
      return type === Decoration_Type.MENTION;
    });
    return decorator(element, mentionDecoration, context);
  }
};

var nodeViewDecorators = [MentionDecorator];

function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var pluginMentions = function pluginMentions(config) {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: MENTION_TYPE,
    nodeViewDecorators: nodeViewDecorators
  };
};

export { MENTION_TYPE, pluginMentions };

import 'wix-rich-content-plugin-mentions/dist/loadable/viewer/es/styles.viewer.min.global.css'